export default __webpack_public_path__ + "static/media/75.32ed0fc1.jpeg";